<script>
import Layout from '@layouts/main'
import api from '@utils/api'
import newItem from './organization-item-new'
import deleteItem from '@views/delete-item-modal'
import Filters from '@views/filters-dialog'
import organizationModel from '@src/models/organization'
import TablePaginator from '@components/paginator'
import userHasRolesToWrite from '@utils/userPermissions'
import AdjustColumnsDialog from '@components/adjust-columns-dialog'
import { hideValues, updateColumns } from '@utils/helpers/columns'

export default {
  name: 'Organizations',
  components: {
    Layout,
    newItem,
    deleteItem,
    Filters,
    TablePaginator,
    AdjustColumnsDialog,
  },
  data() {
    return {
      modelName: 'organization',
      isLoading: false,
      headers: [
        { text: 'short_name', value: 'shortName', sortable: true },
        { text: 'full_name', value: 'fullName', sortable: true, show: true },
        { text: 'status', value: 'status', sortable: true, show: true },
        {
          text: 'description',
          value: 'description',
          sortable: true,
          show: true,
        },
        { text: 'type', value: 'type', sortable: true, show: true },
        {
          text: 'organization_parent',
          value: 'parent',
          sortable: true,
          show: true,
        },
        {
          text: 'main_warehouse',
          value: 'mainWarehouse',
          sortable: true,
          show: true,
        },
        { text: 'city', value: 'city', sortable: true, show: true },
        { text: 'region', value: 'region', sortable: true, show: true },
        { text: 'postcode', value: 'postcode', sortable: true, show: true },
        { text: 'customer', value: 'customer', sortable: true, show: true },
        {
          text: 'securityStock',
          value: 'securityStock',
          sortable: true,
          show: true,
        },
        {
          text: 'delivery_type',
          value: 'deliveryType',
          sortable: true,
          show: true,
        },
        { text: 'actions', value: 'actions', sortable: false },
      ],
      rowsPerPage: [10, 25, 50],
      rolesAllowedToWrite: ['SUPERUSER', 'DICTIONARIES_OPERATOR'],
      page: 1,
      totalPages: 0,
      sortBy: 'shortName',
      descending: false,
      first: false,
      last: false,
      content: [],
      pagination: {},
      totalElements: 0,
      newItem: false,
      showFilters: false,
      multiSelect: true,
      model: organizationModel,
      showDialog: false,
      filters: null,
      fab: false,
    }
  },
  computed: {
    params() {
      return {
        size: this.pagination.rowsPerPage || null,
        page: this.page || null,
        sort_property: this.sortBy || null,
        sort_direction: this.descending,
        ...this.filters,
      }
    },
    userAllowedToCreate() {
      return userHasRolesToWrite(
        this.$store.state.auth.userRole,
        this.rolesAllowedToWrite
      )
    },
    getHeaders() {
      return userHasRolesToWrite(
        this.$store.state.auth.userRole,
        this.rolesAllowedToWrite
      )
        ? this.headers
        : this.headers.slice(0, this.headers.length - 1)
    },
  },
  watch: {
    pagination: {
      handler() {
        this.$store.commit('pagination/SET', {
          name: this.modelName,
          pagination: {
            page: this.page,
            rowsPerPage: this.pagination.rowsPerPage,
            sortBy: this.sortBy,
            descending: this.descending,
          },
        })
      },
      deep: true,
    },
  },
  created() {
    this.getPaginator()
    this.getFilters()
  },
  methods: {
    fetchData() {
      this.isLoading = true
      api.getOrganizations(this.params).then(response => {
        this.content = response.content
        this.totalPages = response.totalPages
        this.first = response.first
        this.last = response.last
        this.page = response.number + 1
        this.pagination = {
          ...this.pagination,
          page: 1,
          rowsPerPage: response.size,
          sortBy: this.sortBy,
          descending: this.descending,
        }
        this.isLoading = false
      })
    },
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value
      )
    },
    openItem(id) {
      this.$router.push(`organizations/${id}`)
    },
    getFilters() {
      const filter = this.$store.getters['filters/getFilters'](this.modelName)
      this.filters = filter ? filter.value : null
      this.fetchData()
    },
    setFilters() {
      const filter = this.$store.getters['filters/getFilters'](this.modelName)
      this.filters = filter ? filter.value : null
      this.showFilters = false
      this.page = 1
      this.fetchData()
    },
    getPaginator() {
      const pagination = this.$store.getters['pagination/get'](this.modelName)
      if (pagination) {
        this.page = pagination.page || 1
        this.sortBy = pagination.sortBy || this.sortBy
        this.descending = pagination.descending || this.descending
        this.pagination.rowsPerPage = pagination.rowsPerPage || 10
      } else {
        this.page = 1
        this.pagination.page = 1
        this.pagination.rowsPerPage = 10
      }
    },
    changePage(value) {
      this.page = value
      this.fetchData()
    },
    changeRowsPerPage(value) {
      if (this.pagination.rowsPerPage === value) return
      this.pagination = {
        ...this.pagination,
        rowsPerPage: value,
      }
      this.page = 1
      this.$store.dispatch('pagination/saveRowsPerPage', value)
      this.fetchData()
    },
    changeSort(header) {
      if (!header.sortable) return
      if (this.sortBy === header.value) {
        this.descending = !this.descending
      } else {
        this.sortBy = header.value
        this.descending = false
      }
      this.fetchData()
    },
    getSortClass(header) {
      return [
        header.sortable ? 'column sortable' : null,
        this.pagination.descending ? 'desc' : 'asc',
        header.value === this.pagination.sortBy ? 'active' : '',
      ]
    },
    hideValues(field) {
      return hideValues(field, this.headers)
    },
    updateColumns(columns) {
      updateColumns(columns, this.headers)
    },
    openDialog() {
      this.showDialog = true
    },
  },
}
</script>

<template>
  <Layout>
    <div slot="actionButton">
      <div class="hidden-xs-only">
        <v-btn 
          color="info" 
          @click="fetchData">
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn
          :color="filters ? `success` : `info`"
          @click="showFilters = true"
        >
          <v-icon>filter_list</v-icon>
        </v-btn>
        <v-btn
          v-if="userAllowedToCreate"
          slot="activator"
          color="primary"
          dark
          @click="newItem = true"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </div>
      <div class="hidden-sm-and-up">
        <v-speed-dial
          v-model="fab"
          direction="left"
          transition="slide-y-reverse-transition"
        >
          <v-btn
            slot="activator"
            v-model="fab"
            color="blue darken-2"
            dark
            fab
            small
            flat
          >
            <v-icon>more_vert</v-icon>
            <v-icon>close</v-icon>
          </v-btn>
          <v-btn
            v-if="userAllowedToCreate"
            color="primary"
            dark
            small
            fab
            @click="newItem = true"
          >
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn
            :color="filters ? `success` : `info`"
            small
            fab
            @click="showFilters = true"
          >
            <v-icon>filter_list</v-icon>
          </v-btn>
          <v-btn 
            color="info" 
            small 
            fab 
            @click="fetchData">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-speed-dial>
      </div>
    </div>
    <v-layout justify-end>
      <v-btn
        icon
        flat
        @click="openDialog()">
        <v-icon>view_column</v-icon>
      </v-btn>
    </v-layout>
    <v-data-table
      :headers="getHeaders"
      :items="content"
      :pagination="pagination"
      :total-items="totalElements"
      :loading="isLoading"
      :class="$style.sdTable"
      hide-actions
    >
      <template 
        slot="headers" 
        slot-scope="props">
        <tr>
          <th
            v-for="header in getHeaders"
            :key="header.text"
            :class="getSortClass(header)"
            :style="[header.show === false ? {'display': 'none'} : {'text-align': 'left'}]"
            @click="changeSort(header)"
          >
            {{ $t(`label__${header.text}`) }}
            <v-icon 
              v-if="header.sortable" 
              small>expand_less</v-icon>
          </th>
        </tr>
      </template>
      <v-progress-linear
        slot="progress"
        height="2"
        color="blue"
        background-color="#E0E0E0"
        indeterminate
      />
      <template 
        slot="items" 
        slot-scope="props">
        <tr 
          :class="$style.sdEditRow" 
          @click="openItem(props.item.id)">
          <td>{{ props.item.shortName }}</td>
          <td v-if="!hideValues('fullName')">{{ props.item.fullName }}</td>
          <td v-if="!hideValues('status')">{{ $t(`organizationstatus.${props.item.status}.name`) }}</td>
          <td v-if="!hideValues('description')">{{ props.item.description }}</td>
          <td v-if="!hideValues('type')">{{ $t(`organizationtype.${props.item.type}.name`) }}</td>
          <td v-if="!hideValues('parent')">{{ getValue('organization', props.item.parent) || '-' }}</td>
          <td v-if="!hideValues('mainWarehouse')">
            {{ getValue('organization', props.item.mainWarehouse) || '-' }}
          </td>
          <td v-if="!hideValues('city')">{{ getValue('city', props.item.city) }}</td>
          <td v-if="!hideValues('region')">{{ getValue('region', props.item.region) }}</td>
          <td v-if="!hideValues('postcode')">{{ props.item.postcode || '-' }}</td>
          <td v-if="!hideValues('customer')">{{ props.item.customer }}</td>
          <td v-if="!hideValues('securityStock')">{{ props.item.securityStock || '-' }}</td>
          <td v-if="!hideValues('deliveryType')">{{ $t(`deliverytype.${props.item.deliveryType}.name`) }}</td>
          <td 
            v-if="userAllowedToCreate" 
            class="text-xs-left">
            <delete-item
              :item-id="props.item.id"
              :item-name="props.item.shortName"
              :table-name="`organization`"
              @item-deleted="fetchData(params)"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
    <table-paginator
      :page="page"
      :total-pages="totalPages"
      :first="first"
      :last="last"
      :rows-per-page="pagination.rowsPerPage"
      @change-page="changePage($event)"
      @change-rows-per-page="changeRowsPerPage($event)"
    />
    <adjust-columns-dialog
      v-model="showDialog"
      :headers="headers.filter(h => h.show !== undefined)"
      :model-name="modelName"
      @columns-updated="updateColumns"
    />
    <new-item 
      :new-item="newItem" 
      @close-modal="newItem = false" />
    <filters
      :visible="showFilters"
      :model="model"
      :model-name="modelName"
      :multi-select="multiSelect"
      @close-modal="showFilters = false"
      @filters-confirmed="setFilters()"
    />
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }
}
.sdEditRow {
  cursor: pointer;
}
.sdBorder {
  border: 1px solid #dfdfdf;
  border-bottom: none;
}
</style>
